import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AnimationItem } from "lottie-web";
import { FE_StickerPack } from "@shared/models/integration";
import { MediaService } from "@shared/services/media.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { LottieComponent } from "ngx-lottie";
import { TranslatePipe } from "@ngx-translate/core";

export class StickerPackPreviewMoadlInstance {
    public pack: FE_StickerPack;
}

@Component({
    templateUrl: "./preview.component.html",
    styleUrls: ["./preview.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LottieComponent, TranslatePipe]
})
export class AdminStickerPackPreviewComponent {

    readonly PLACEHOLDER = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAgMTIwIj48cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgZmlsbD0iI2Q1ZDVkNSIvPjwvc3ZnPg==';

    pack: FE_StickerPack;
    visibleCount = 20;
    loadedImages = new Set<number>();
    private readonly animationItems = new Map<number, AnimationItem>();

    constructor(
        public modal: NgbActiveModal, private readonly media: MediaService) {
    }

    get displayedStickers() {
        return this.pack.stickers.slice(0, this.visibleCount);
    }

    get hasMore(): boolean {
        return this.pack.stickers.length > this.visibleCount;
    }

    public loadMore(): void {
        this.visibleCount += 20;
    }

    public trackByIndex(index: number): number {
        return index;
    }

    public getThumbnailUrl(mxc: string, width: number, height: number, method: "crop" | "scale" = "scale"): string {
        return this.media.getThumbnailUrl(mxc, width, height, method, true);
    }

    public onImageLoad(index: number): void {
        this.loadedImages.add(index);
    }

    public onAnimationCreated(index: number, animationItem: AnimationItem): void {
        this.animationItems.set(index, animationItem);
    }

    public onStickerHover(index: number): void {
        const anim = this.animationItems.get(index);
        if (anim) {
            anim.goToAndPlay(0, true);
        }
    }
}
